var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.switcherEnable)?_c('div',{staticClass:"domains-switcher",class:{ 'domains-switcher--om': _vm.isOM },on:{"click":_vm.switchDomain}},[_c('img',{staticClass:"domains-switcher__icon",attrs:{"src":_vm.icon,"alt":`icon-${_vm.domainText}`}}),_c('span',{staticClass:"domains-switcher__text"},[_vm._v(" "+_vm._s(_vm.domainText)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }